export default "__VITE_ASSET__ad62a220__"